import { isApiError } from '@/lib/apiClient';
import { useTranslation } from 'react-i18next';

export const useErrorTranslation = () => {
  const { t: tError } = useTranslation('utils', { keyPrefix: 'error' });

  const translateError = (error: unknown, fallback?: string) => {
    const fallbackMessage = fallback ?? tError('GENERAL_ERROR');

    if (isApiError(error)) {
      const firstError = error.response?.data?.errors?.[0];
      if (!firstError) {
        return fallbackMessage;
      }
      return tError(firstError.code as never, fallbackMessage);
    }

    if (error instanceof Error) {
      return tError(error.name as never, fallbackMessage);
    }

    return fallbackMessage;
  };

  return { translateError } as const;
};
